import React, {Fragment, useEffect, useState} from "react";
import {useAdvancedSearchMutation} from "../../core/api/rogerthat-state-api";
import AdvancedSearch from "./index";
import {useAdvancedSearchTOHMutation} from "../../core/api/toh-state-api";

export default function AdvancedSearchTOH() {

    return <AdvancedSearch useSearchHook={useAdvancedSearchTOHMutation} />
}